import tables from '@df/js/components/tables';
import Tooltip from "@components/Tooltip/Tooltip";
import tooltip from "@df/js/components/tooltip";
import { __ } from "@wordpress/i18n";

const classNames = require('classnames');

// WP react stuff
import {useEffect, useState} from '@wordpress/element';

const Table = ({
        headers,
        data,
        noMobile,
        firstRow = [],
        loadMoreBtn = false,
        hasMoreRows = false,
        onLoadMore
    }) => {

    // Init tables
    useEffect(() => {
        tables.init();

        tooltip.closeAll();
        tooltip.init()
    }, [data]);

    const tableClasses = classNames({
        table: true,
        'w-full': true,
        'no-mobile': noMobile,
    });

    const visibleData = data;

    const renderCellValue = (cell) => {
        if (cell.truncate && cell.tooltip && typeof cell.value === "string") {
            const limit = cell.limit || 19;
            const isLong = cell.value.length > limit;

            return (
            <span className="inline-flex items-center gap-1 justify-between">
                <span className='whitespace-nowrap'>{isLong ? `${cell.value.slice(0, limit)}...` : cell.value}</span>
                {isLong && (
                <Tooltip
                title={cell.tooltipTitle || cell.value}
                iconClass={cell.tooltipIcon || 'info-icon'}
                placement={'top'}
                >{cell.tooltipContent || cell.value}</Tooltip>
                )}
            </span>
            );
        }

        return <span dangerouslySetInnerHTML={{ __html: cell.value }} />;
    };

    return (
        <>
            {data && <div className="table-block-wrapper !pb-0">
                <table className={tableClasses}>
                    {headers &&
                        <thead>
                        <tr>
                            {headers.map((header) => (
                                <th
                                    key={header.value}
                                    colSpan={header.span || 1}
                                    className={header.className}
                                    dangerouslySetInnerHTML={{__html: header.value}}
                                />
                            ))}
                        </tr>
                        </thead>
                    }
                    <tbody>
                    {
                        firstRow.length !== 0 && <tr className={"bg-blue-5"}>
                            {firstRow.map((cell, cellIndex) => (
                                <td key={`first-row-cell-${cellIndex}`} className={cell.className}>
                                {renderCellValue(cell)}
                                </td>
                            ))}
                        </tr>
                    }
                    {visibleData.map((row, index) => (
                        <tr key={`row-${index}`}>
                            {row.map((cell, cellIndex) => (
                                <td key={`cell-${index}-${cellIndex}`} className={cell.className}>
                                {renderCellValue(cell)}
                                </td>
                            ))}
                        </tr>
                    ))}
                    </tbody>

                    {loadMoreBtn && hasMoreRows && (
                        <tfoot>
                            <tr>
                            <td className="text-center" colSpan={headers.length}>
                                <button
                                role="button"
                                className="btn btn-primary text-blue-100"
                                onClick={onLoadMore}
                                >
                                {__("Ver mais resultados", "df-simulators")}
                                </button>
                            </td>
                            </tr>
                        </tfoot>
                    )}
                </table>
            </div>}
        </>
    );
};


export default Table;
